export default {
  fi: {
    ServiceEventCreateScene: {
      addServiceEvent: 'Lisää huolto',
      confirmLeave: 'Haluatko varmasti poistua sivulta? Tallentamattomat tiedot menetetään.',
      attachmentsAfterCreateInfo:
        'Voit lisätä huoltotapahtumalle liitetiedostoja tallentamisen jälkeen.',
      addAttachmentsPromptTitle: 'Tiedot tallennettu. Haluatko lisätä liitetiedostoja huoltotapahtumaan?',
      addAttachmentsPromptYes: 'Kyllä',
      addAttachmentsPromptNo: 'Ei',
    },
  },
};
